import { useChat } from '@ai-sdk/react'
import { DefaultChatTransport } from 'ai'

import { HELP_BOT_API } from '../constants'
import type { HelpUIMessage } from '../types'

// The same streaming hook the docs site uses, pointed at the help bot. Gives
// messages, sendMessage, and status, and parses the `data-sources` part for free.
export function useHelpBot() {
  return useChat<HelpUIMessage>({
    transport: new DefaultChatTransport({ api: HELP_BOT_API }),
  })
}
